import { LOGO_URL } from "@/lib/api";

// The brand PNG has large transparent padding around the artwork.
// We crop into the centered artwork by scaling within an overflow-hidden box
// so the visible mark is large and consistent across placements.
export const BrandLogo = ({ h = 64, className = "", ...rest }) => {
  const w = Math.round(h * 2.4);
  return (
    <div
      className={"overflow-hidden shrink-0 " + className}
      style={{ width: `${w}px`, height: `${h}px` }}
      {...rest}
    >
      <img
        src={LOGO_URL}
        alt="Just Peptides Supply"
        style={{
          width: `${w}px`,
          height: `${h}px`,
          objectFit: "contain",
          transform: "scale(2.5)",
          transformOrigin: "center 47%",
        }}
      />
    </div>
  );
};
